var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import SyncAlt from '@mui/icons-material/SyncAlt';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { infoSelect, productSyncToDateLake } from 'services/api/product-service';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { getFilteredProducts } from 'services/api/search-filter-build-products';
import { DATALAKE_SCOPES, PRODUCT_CLASS_ALLOWED } from 'utils/constants';
import { LoadingSpinner } from 'components/Shared/Loading/LoadingSpinner/LoadingSpinner';
import { useSnackbar } from 'context/snackbar/SnackBarProvider';
import { searchForParentByChildId } from 'services/api/search-kits';
import { useCheckAuthScope } from 'services/helperFunctions/useCheckAuthScope';
import { CatalogHierarchies } from './CatalogHierarchies/CatalogHierarchies';
import { ProductCodes } from './ProductCodes/ProductCodes';
import { ProductDetails } from './ProductDetails/ProductDetails';
import { CustomDetails } from './CustomDetails/CustomDetails';
import { OptionsInfoTab } from './OptionsInfoTab/OptionsInfoTab';
import styles from './ProductInfoPage.module.scss';
export function ProductInfoPage() {
    var _this = this;
    var _a, _b;
    var loaderData = useLoaderData();
    var setSnackbarAlert = useSnackbar().setSnackbarAlert;
    var userHasDataLakePrivileges = useCheckAuthScope(DATALAKE_SCOPES);
    var throwErrorAlert = useCallback(function () {
        setSnackbarAlert({
            message: 'Server Error - Please report the error to the PLS support board/help desk with details',
            type: 'error',
        });
    }, [setSnackbarAlert]);
    useEffect(function () {
        if (loaderData.isError) {
            throwErrorAlert();
        }
        if (loaderData.isFeatureError) {
            setSnackbarAlert({
                message: 'Error loading feature details - some features may be missing',
                type: 'error',
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var searchParams = loaderData.searchParams;
    var navigate = useNavigate();
    var handleBackwardsNavigate = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (searchParams.origin) {
                switch (searchParams.origin) {
                    case 'simple':
                        navigate("/search/simple/product");
                        break;
                    case 'advanced':
                        navigate('/search/advanced');
                        break;
                    case 'hierarchy':
                        navigate('/search/hierarchy');
                        break;
                    default:
                        break;
                }
            }
            return [2 /*return*/];
        });
    }); };
    var showCustom = useMemo(function () { var _a, _b, _c; return PRODUCT_CLASS_ALLOWED.includes((_c = (_b = (_a = loaderData.infoRsp.body.details) === null || _a === void 0 ? void 0 : _a.header) === null || _b === void 0 ? void 0 : _b.productClass) !== null && _c !== void 0 ? _c : ''); }, [(_b = (_a = loaderData.infoRsp.body.details) === null || _a === void 0 ? void 0 : _a.header) === null || _b === void 0 ? void 0 : _b.productClass]);
    var linkToBuild = {
        label: 'Use for Product Build',
    };
    var syncToSnowFlake = {
        label: 'Sync to SnowFlake',
    };
    function handleLinkClick() {
        return __awaiter(this, void 0, void 0, function () {
            var rsp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoading(true);
                        return [4 /*yield*/, getFilteredProducts(searchParams.prefix, searchParams.date, searchParams.time, searchParams.channel)];
                    case 1:
                        rsp = _a.sent();
                        navigate("/product-build/build?productNbr=".concat(searchParams.prefix, "&date=").concat(searchParams.date, "&time=").concat(searchParams.time, "&channel=").concat(searchParams.channel, "&pid=").concat(searchParams.id, "&productVersion=").concat(searchParams.version), {
                            state: {
                                data: rsp,
                                totalCount: rsp.data.resultsCount,
                                selectedProdVersion: searchParams.version,
                                navigatedFrom: 'productInfo',
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function handleSnowflakeSync() {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var processingTime, snowflakeSyncRequest, infoRsp;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        processingTime = new Date().getTime();
                        snowflakeSyncRequest = {
                            id: "".concat(processingTime, "_").concat(searchParams.id),
                            'detail-type': 'PRODUCT_VERSION_UPDATED',
                            source: 'ProductInfoPageV2Sync',
                            time: processingTime,
                            detail: {
                                productId: Number((_a = searchParams.id.match(/\d+/)) === null || _a === void 0 ? void 0 : _a[0]),
                                productVersion: searchParams.version,
                            },
                        };
                        return [4 /*yield*/, productSyncToDateLake(snowflakeSyncRequest)];
                    case 1:
                        infoRsp = _b.sent();
                        if (infoRsp.status === 200) {
                            setSnackbarAlert({
                                message: 'Product successfully published to datalake sync queue',
                                type: 'success',
                            });
                        }
                        else {
                            setSnackbarAlert({
                                message: 'Product unable to publish to datalake sync queue. Please check producer lambda',
                                type: 'error',
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    return (_jsx(Box, __assign({ sx: { margin: '0 40px' } }, { children: !isLoading ? (_jsxs(Box, { children: [loaderData.infoRsp.status === 200 && (_jsxs(_Fragment, { children: [_jsxs(Button, __assign({ onClick: function () { return handleBackwardsNavigate(); }, sx: { width: '100px' } }, { children: [_jsx(KeyboardBackspaceIcon, {}), _jsx("span", __assign({ style: {
                                        marginLeft: '20px',
                                        fontFamily: 'UntitledSansMedium, sans-serif, system-ui',
                                        fontSize: '16px',
                                    } }, { children: "Back" }))] })), _jsx("hr", { className: styles.hr }), _jsxs(Box, __assign({ className: styles.container }, { children: [_jsxs(Box, __assign({ className: styles.headerContainer }, { children: [_jsx(ProductDetails, { infoResponse: loaderData.infoRsp.body, pid: searchParams.id, version: searchParams.version, kitParentArray: loaderData.kitParentArray }), _jsx(ProductCodes, { infoResponse: loaderData.infoRsp.body }), _jsxs(Box, __assign({ className: styles.catalogContainer }, { children: [_jsx(CatalogHierarchies, { infoResponse: loaderData.infoRsp.body }), _jsx("hr", { className: styles.hr }), _jsx(Box, __assign({ style: { height: '60px', display: 'flex' } }, { children: _jsxs(Button, __assign({ className: styles.lookUpButton, onClick: function () { return handleLinkClick(); } }, { children: [_jsx(EditIcon, { sx: { height: '18px', width: '18px' } }), _jsxs("span", __assign({ style: { paddingLeft: '8px' } }, { children: [" ", linkToBuild.label] }))] })) })), userHasDataLakePrivileges && (_jsx(Box, __assign({ style: { height: '60px', display: 'flex' } }, { children: _jsxs(Button, __assign({ className: styles.lookUpButton, onClick: function () { return handleSnowflakeSync(); } }, { children: [_jsx(SyncAlt, { sx: { height: '18px', width: '18px' } }), _jsxs("span", __assign({ style: { paddingLeft: '8px' } }, { children: [" ", syncToSnowFlake.label] }))] })) })))] }))] })), showCustom ? _jsx(CustomDetails, { infoResponse: loaderData.infoRsp.body }) : null] })), _jsx(OptionsInfoTab, { featuresData: loaderData.infoFeatureRsp, infoResponse: loaderData.infoRsp.body })] })), loaderData.infoRsp.status === 400 && (_jsx(Box, __assign({ style: { textAlign: 'center', marginTop: '25px' } }, { children: loaderData.infoRsp.body.message })))] })) : (_jsx(LoadingSpinner, { indicatorSize: 10 })) })));
}
export function ProductInfoPageLoader(_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var request = _a.request;
    return __awaiter(this, void 0, void 0, function () {
        var isError, sParams, searchParams, infoRsp, kitParentArray, listOfParents, featuresList, infoFeatureRsp, isFeatureError, BATCH_SIZE, i, batch, batchResults, j, result, infoFeatureMap;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    isError = false;
                    sParams = new URL(request.url).searchParams;
                    searchParams = {
                        prefix: sParams.get('prefix'),
                        date: sParams.get('date'),
                        time: sParams.get('time'),
                        channel: sParams.get('channel'),
                        id: sParams.get('pid'),
                        version: sParams.get('productVersion'),
                        parsedProductId: sParams.get('parsedProductId'),
                        origin: sParams.get('origin'),
                    };
                    sessionStorage.removeItem('latestValidate');
                    sessionStorage.setItem('productVersion', (_b = searchParams.version) !== null && _b !== void 0 ? _b : '');
                    return [4 /*yield*/, infoSelect({
                            productVersion: (_c = searchParams.version) !== null && _c !== void 0 ? _c : '',
                            productId: (_d = searchParams.id) !== null && _d !== void 0 ? _d : '',
                            processingDate: "".concat(searchParams.date, "T").concat(searchParams.time, ".000Z"),
                        }, 'header,features,featureswithfabricflag,hierarchy')];
                case 1:
                    infoRsp = _j.sent();
                    if (infoRsp.status >= 500) {
                        isError = true;
                    }
                    kitParentArray = [];
                    if (!!((_f = (_e = infoRsp.body.details) === null || _e === void 0 ? void 0 : _e.header) === null || _f === void 0 ? void 0 : _f.kitParent)) return [3 /*break*/, 3];
                    return [4 /*yield*/, searchForParentByChildId(searchParams.id, searchParams.date)];
                case 2:
                    listOfParents = _j.sent();
                    kitParentArray = listOfParents;
                    _j.label = 3;
                case 3:
                    featuresList = (_h = (_g = infoRsp.body.details) === null || _g === void 0 ? void 0 : _g.features) !== null && _h !== void 0 ? _h : [];
                    infoFeatureRsp = [];
                    isFeatureError = false;
                    if (!!isError) return [3 /*break*/, 7];
                    BATCH_SIZE = 50;
                    i = 0;
                    _j.label = 4;
                case 4:
                    if (!(i < featuresList.length)) return [3 /*break*/, 7];
                    batch = featuresList.slice(i, i + BATCH_SIZE);
                    return [4 /*yield*/, Promise.allSettled(batch.map(function (k) {
                            var _a, _b;
                            return k.hasFabric
                                ? infoSelect({ featureId: k.featureId, productVersion: (_a = searchParams.version) !== null && _a !== void 0 ? _a : '' }, 'feature', true)
                                : infoSelect({ featureId: k.featureId, productVersion: (_b = searchParams.version) !== null && _b !== void 0 ? _b : '' }, 'options,feature', false);
                        }))];
                case 5:
                    batchResults = _j.sent();
                    for (j = 0; j < batchResults.length; j += 1) {
                        result = batchResults[j];
                        if (result.status === 'fulfilled') {
                            if (result.value.status >= 400) {
                                isFeatureError = true;
                            }
                            else {
                                infoFeatureRsp.push(result.value);
                            }
                        }
                        else {
                            isFeatureError = true;
                        }
                    }
                    _j.label = 6;
                case 6:
                    i += BATCH_SIZE;
                    return [3 /*break*/, 4];
                case 7:
                    infoFeatureMap = infoFeatureRsp.map(function (ifri) { return ifri.body.details.feature; });
                    infoFeatureRsp.forEach(function (item) {
                        var _a, _b;
                        if ((_b = (_a = item.body.details) === null || _a === void 0 ? void 0 : _a.feature) === null || _b === void 0 ? void 0 : _b.nonStandardIndicator) {
                            var nsoItem = item.body.details.feature;
                            var deps = Object.values(nsoItem === null || nsoItem === void 0 ? void 0 : nsoItem.dependencyRules);
                            var keyArray_1 = [];
                            deps.forEach(function (dep) {
                                var dependencies = Object.entries(dep.dependencies);
                                var depConfig = {
                                    featureId: dependencies[0][0],
                                    optionCode: dependencies[0][1],
                                };
                                keyArray_1.push(depConfig);
                            });
                            var listOfGroupCodes_1 = [];
                            keyArray_1.forEach(function (dep) {
                                var i = infoFeatureMap.findIndex(function (ifmi) { return dep.featureId === ifmi.featureId; });
                                if (i === -1) {
                                    return;
                                }
                                if (infoFeatureMap[i].options[dep.optionCode].nonStandardGroupCode) {
                                    listOfGroupCodes_1.push(infoFeatureMap[i].options[dep.optionCode].nonStandardGroupCode);
                                }
                            });
                            item.body.details.feature.nonStandardGroupCodes = listOfGroupCodes_1;
                        }
                    });
                    return [2 /*return*/, { infoRsp: infoRsp, infoFeatureRsp: infoFeatureRsp, searchParams: searchParams, kitParentArray: kitParentArray, isError: isError, isFeatureError: isFeatureError }];
            }
        });
    });
}
